import { CSSProperties } from 'react'
import clsx from 'clsx'

import RichText from 'lib/sanity/richText'

import { defaultPagebuilderAlign, mapPagebuilderAlignToJustifyContent } from '../mappers'
import { PagebuilderDescriptionViewModel } from '../types'
import { resolveMaxContentWidth } from '../utils'

import styles from './Description.module.scss'

interface DescriptionProps {
  description?: PagebuilderDescriptionViewModel
  className?: string
}

const Description = ({ description, className }: DescriptionProps) => {
  if (!description) return null

  if (!description.content) return null

  const desktopAlign = description.alignDesktop ?? defaultPagebuilderAlign
  const mobileAlign = description.alignMobile ?? defaultPagebuilderAlign
  const maxContentWidth = resolveMaxContentWidth(description)

  const wrapperStyle = {
    '--desktop-align-items': mapPagebuilderAlignToJustifyContent(desktopAlign),
    '--desktop-text-align': desktopAlign,
    '--mobile-align-items': mapPagebuilderAlignToJustifyContent(mobileAlign),
    '--mobile-text-align': mobileAlign,
    '--max-content-width': maxContentWidth
  } as CSSProperties

  return (
    <div className={clsx(styles.descriptionWrapper, className)} style={wrapperStyle}>
      <div className={styles.contentWrapper}>
        <RichText value={description.content} />
      </div>
    </div>
  )
}

export default Description
